import type { Modal } from '@ps/web-core-store';
import { CrossPlatformLink } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import CMSHTML from '../../../../../CMSHTML/CMSHTML';
import type { Props } from '../../TopHeader';

import styles from './RegulatoryHeaderUK.scss';

// eslint-disable-next-line @typescript-eslint/naming-convention
const RegulatoryHeaderUK: React.FC<Props> = ({ regulatory_header }) => {
  const restrictDepositLimits = '/account/responsible/restrict-deposit-limit-extended';
  const { modal } = useDispatch<Dispatch>();
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const content = regulatory_header ? regulatory_header[0]?.texts[0]?.content : '';
  const openAfterLogin = (locationParams: Modal) =>
    isAuthenticated
      ? modal.enqueue(locationParams)
      : modal.enqueue({ path: '/auth/login', locationState: locationParams });

  const openRestrictDepositLimit = () => openAfterLogin({ path: restrictDepositLimits });

  return (
    <div className={styles.responsibleGaming}>
      <CrossPlatformLink
        href={restrictDepositLimits}
        className={styles.regulatoryIconText}
        onClick={openRestrictDepositLimit}
      >
        <CMSHTML className={styles.regulatoryText} content={content} />
      </CrossPlatformLink>
    </div>
  );
};

export default RegulatoryHeaderUK;
